import classNames from 'classnames';
import React, {FC, MouseEvent, ReactNode} from 'react';
import RsnLoader from '~/shared/legacy_presentational-components/Rsn/Loader/RsnLoader';
import styles from '../commonButtonStyles/RsnButtonStyles.module.scss';

export interface RsnButtonProps {
    title: string;
    onClickCallback?: () => void;
    className?: string;
    isLoading?: boolean;
    disabled?: boolean;
    gotItButton?: boolean;
    whiteButton?: boolean;
    lightBlueButton?: boolean;
    originalCaseTitle?: boolean;
    form?: string;
    type?: 'button' | 'submit';
    children?: ReactNode;
}

/**
 * @deprecated
 * @see {@link '@raison/ui-kit'.RsnButton}
 */
const RsnButton: FC<RsnButtonProps> = ({
    title,
    children,
    onClickCallback,
    className,
    isLoading,
    disabled,
    gotItButton,
    whiteButton,
    lightBlueButton,
    form,
    // FIXME remove type and use separate RsnSubmitButton component for submit buttons
    type,
    originalCaseTitle,
}) => {
    const getStyles = classNames(styles.buttonDefault, {
        [styles.gotItButton]: gotItButton,
        [styles.whiteButton]: whiteButton,
        [styles.lightBlueButton]: lightBlueButton,
        [styles.nonCapsedFont]: originalCaseTitle,
        [`${className}`]: className,
    });

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClickCallback?.();
    };

    return (
        <button disabled={isLoading || disabled} className={getStyles} onClick={handleClick} type={type} form={form}>
            {originalCaseTitle ? title : title.toUpperCase()}
            {isLoading && <RsnLoader className={styles.loader} />}
            {children}
        </button>
    );
};

export default RsnButton;
